<template>
  <div></div>
</template>
<script>
export default {
  name: "EdenPageProgress",
};
</script>
